<script lang="ts">
    let className: string = "";
    export { className as class };
</script>

<svg
    class="{className}"
    viewBox="0 0 20 20"
    id="iD-icon-minus"
    xmlns="http://www.w3.org/2000/svg"
    ><path
        d="M15 8.75a1.25 1.25 0 010 2.5H5a1.25 1.25 0 010-2.5h10z"
        class="svelte-pvlu0y" /></svg>
